import "Features/Tenants/tenants.index.css";
import { parseAndFormatDate } from "Utilities/common";

export const LicenseInfoRenderer = (_: any, record: any) => {
  const parseDateTime = () => {
    try {
      if (!record?.licenseExpiry) {
        return "N/A";
      }

      const formattedDateTime = parseAndFormatDate(record?.licenseExpiry);

      return formattedDateTime;
    } catch {
      return "N/A";
    }
  };

  return <> {record.licenseExpiry && `${parseDateTime()}`}</>;
};
